import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const PopupChart = ({ data }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (chartRef.current) {
            const chartInstance = echarts.init(chartRef.current);

            const categories = [...new Set(data.map(item => item.category))];
            const years = [...new Set(data.map(item => item.year))];

            // Custom bright color palette
            const colorPalette = [
                '#752e3c', '#d06b4f', '#e1a84b', '#c49a6c', '#caa85e',
                '#94a964', '#7fa98e', '#5b8c9b', '#a94442'
            ];

            // Assign colors to categories using the palette
            const colorMapping = {};
            categories.forEach((category, index) => {
                colorMapping[category] = colorPalette[index % colorPalette.length];
            });

            const series = categories.map(category => ({
                name: category,
                type: 'bar',
                stack: 'total',
                barWidth: '10%',
                data: data
                    .filter(item => item.category === category)
                    .map(item => item.expenses),
                itemStyle: { color: colorMapping[category] }
            }));

            const option = {
                tooltip: { trigger: 'axis' },
                grid: {
                    containLabel: true,
                    left: '10%',
                    right: '10%',
                    bottom: '25%',
                    top: '15%',
                },
                xAxis: {
                    type: 'category',
                    data: years,
                    splitLine: { show: false },
                    axisLabel: { color: '#000' },
                    axisTick: { show: false },
                },
                yAxis: {
                    type: 'value',
                    splitLine: { show: false },
                    name: 'Amount in $',
                    axisLine: { show: true },
                    nameLocation: 'middle',
                    nameGap: 60,
                    nameTextStyle: { color: '#000' },
                    axisLabel: {
                        color: '#000',
                        formatter: (value) => {
                            if (value >= 1_000_000) {
                                return `$${(value / 1_000_000).toFixed(0)}M`;
                            } else if (value >= 1_000) {
                                return `$${(value / 1_000).toFixed(0)}K`;
                            }
                            return `$${value}`;
                        }
                    }
                },
                series,
                legend: {
                    data: categories,
                    orient: 'horizontal',
                    bottom: '-2%',
                    icon: 'rect',
                    itemWidth: 7,
                    itemHeight: 7,
                    selectedMode: 'multiple'
                }
            };

            chartInstance.setOption(option);

            return () => {
                chartInstance.dispose();
            };
        }
    }, [data]);

    return <div ref={chartRef} style={{ width: '100%', height: '100%' }} />;
};

export default PopupChart;
